import { ArrowRightLeftIcon } from 'lucide-react'

import { DepositToSavingsAction } from './types'
import { Token } from '@/domain/types/Token'
import { ActionRow } from '@/features/actions/components/action-row/ActionRow'
import { ActionRowBaseProps } from '@/features/actions/components/action-row/types'

export interface DepositToSavingsActionRowProps extends ActionRowBaseProps {
  action: DepositToSavingsAction
}

export function DepositToSavingsActionRow({
  action: { savingsToken, token, value, underlyingToken, displayMode },
  ...props
}: DepositToSavingsActionRowProps) {
  const [titleTokens, title]: [Token[], string] = (() => {
    if (displayMode === 'savings') {
      return [[savingsToken], `Deposit to ${savingsToken.symbol}`]
    }

    if (underlyingToken.symbol === token.symbol) {
      return [[token], `Deposit ${token.symbol}`]
    }

    return [[token, underlyingToken], `Swap for ${underlyingToken.symbol} and deposit`]
  })()

  return (
    <ActionRow {...props}>
      <ActionRow.Icon icon={ArrowRightLeftIcon} />

      <ActionRow.Title>
        <ActionRow.Title.Tokens tokens={titleTokens} />
        {title}
      </ActionRow.Title>

      <ActionRow.Amount token={savingsToken} amount={value} />

      <ActionRow.ErrorWarning />

      <ActionRow.Trigger>Deposit</ActionRow.Trigger>
    </ActionRow>
  )
}
